import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import CommentIcon from '../../Icons/CommentIcon';
import styles from './CommentCard.module.scss';
import EditIcon from '../../Icons/EditIcon'

import 'photoswipe/dist/photoswipe.css'
import { Gallery, Item } from 'react-photoswipe-gallery'

export default function CommentCard({
  onEditComment,
  photo, photos,
  comment,
  width: propWidth,
  height: propHeight,
  canEdit,
}) {
  const { t } = useTranslation();
  const [dimensions, setDimensions] = useState({ width: propWidth, height: propHeight });

  useEffect(() => {
    if (!propWidth || !propHeight) {
      const img = new Image();
      img.src = photo;
      img.onload = () => {
        setDimensions({ width: img.width, height: img.height });
      };
    }
  }, [photo, propWidth, propHeight]);

  return (
    <div className={styles.commentCard}>
      <div className={styles.commentCard__header}>
        <CommentIcon />
        {t('Comment')}
      </div>
      {
        photos.length
          ? <Gallery withDownloadButton dataSource={photos.map((url, i) => ({
              sourceId: i+1, // needed to connect following data with Item component
              original: url,
              thumbnail: url,
              width: dimensions.width,
              height: dimensions.height,
            }))}>
              <Item
                sourceId={1} // needed to connect following data with Item component
                original={photo}
                thumbnail={photo}
                width={dimensions.width}
                height={dimensions.height}
                target="_blank"
              >
                {({ ref, open }) => (
                  <div className={styles.commentCard__imageContainer}>
                    <img className={styles.commentCard__image} ref={ref} onClick={open} src={photo} alt='comment' />
                    <div className={styles.commentCard__imageOverlay}>
                      <div>{photos.length} {t('photos available')}</div>
                      <div>{t('Click to open Galley')}</div>
                    </div>
                  </div>
                )}
              </Item>
            {
              photos.slice(1).map((url, i) => {
                return (
                  <Item
                    key={i}
                    sourceId={i+2}
                    original={url}
                    thumbnail={url}
                    width={dimensions.width}
                    height={dimensions.height}
                    target="_blank"
                  >
                    {({ ref, open }) => (
                      <img style={{display: 'none'}} ref={ref} src={url} alt='comment' />
                    )}
                  </Item>
                )
              })
            }
            </Gallery>
          : null
      }
      <div className={styles.commentCard__body}>
        <span
          className={styles.commentCard__text}>
          {comment || ''}
        </span>
        {
          canEdit
            ? <div className={styles.editButton} onClick={onEditComment}>
                <EditIcon />
              </div>
            : null
        }
      </div>
      
      
    </div>
  );
}